import * as type from './types'
import actions from './actions'
import getters from './getters'

const state = {
  lang: 'en'
}
const mutations = {
  [type.SET_WRLD_USER_LANG](state, action) {
    state.lang = action.lang
  }
}


export const wrldUser = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
